export default __webpack_public_path__ + "static/media/maven-config.5d96d768.md";